<select (ngModelChange)="selectSort($event)" [ngModel]="sortOption" class="select form-select">
  @for (option of sortOptionsPerPage[salesPage]; track option) {
    <option [value]="option">
      {{ 'offering.dropdown-sort.' + option.split(',')[0].toLowerCase() + '-' + option.split(',')[1].toLowerCase() | translate }}
    </option>
  }
</select>

